import React from 'react';
import clsx from 'clsx';
import * as Styled from './AVideo.styles';
import { type AVideoProps, AVideoAspectRatio } from './AVideo.types';

const COMPONENT_NAME = 'a-web-ui-kit-AVideo';
const TEST_ID = 'web-ui-kit-AVideo';

export function AVideo(props: AVideoProps): React.ReactElement {
  const {
    aspectRatio = AVideoAspectRatio.Ratio16x9,
    className,
    src,
    poster,
    title,
    autoPlay = false,
    loop = false,
    muted = false,
    controls = true,
    playsInline = true,
    ...restProps
  } = props;

  return (
    <Styled.VideoWrapper
      className={clsx('a-video', className)}
      aspectRatio={aspectRatio}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      {...restProps}
    >
      <Styled.VideoElement
        src={src}
        poster={poster}
        title={title}
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        controls={controls}
        playsInline={playsInline}
        data-testid={`${TEST_ID}-element`}
      />
    </Styled.VideoWrapper>
  );
}

export * from './AVideo.types';
export { TEST_ID as A_VIDEO_TEST_ID };
